export enum RoleId {
  VIP = 1,
  IAM=1,
  AllstateExternalAdministrator = 2,
  FieldVicePresident = 4,
  Producer = 5,
  FieldSalesLeader = 6,
  AgencyAdministrator = 7,
  AgencySupportWithPolicies = 11,
  AgencySupportWithAccounts = 10,
  AgencySupportWithCommissionsAnd1099s = 8,
  AgencySupportWithClaims = 12,
  AgencySupportWithPolicyServiceRequest = 14,
  AgencySupportWithCorrespondence = 13,
  AgencySupportWithUnderwritingRequirements = 15,
  Marketing = 9,
}
